import style from './list-access.scss';
import { isAndroidOS, isIOS } from './../../../assets/js/mobile-detect';

const script = () => {
  const cssClass: string = 'ListAccess';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;

    // Create itinerary link
    if (elt.hasAttribute('data-lat') && elt.hasAttribute('data-lng')) {

      // Get latitude and longitude
      const lat = elt.getAttribute('data-lat');
      const long = elt.getAttribute('data-lng');

      // Get initial value of elt
      const label = elt.textContent;
      elt.innerHTML = '';

      // Create new link for itinerary
      const link = document.createElement('a');
      let mapLink = `https://www.google.com/maps/search/?api=1&query=${lat},${long}`;
      link.classList.add(`${cssClass}-link`);
      link.target = '_blank';
      link.textContent = label;

      // If we are on Android OS or IOS, link change
      if (isAndroidOS || isIOS) {
        let path = '';
        link.removeAttribute('target');

        if (isAndroidOS) {
          path = 'geo:0,0?q=';
        }

        if (isIOS) {
          path = ' maps://?q=';
        }

        mapLink = `${path}${lat},${long}`;
      }
      link.href = mapLink;
      elt.appendChild(link);
    }
  }
};

export {
  style,
  script,
};
